import { Box, Typography, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import { day7, last15days, month1, oneDay } from "assets";

const imageContainerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  justifyContent: "flex-end",
  textAlign: "end",
  padding: 0,
  margin: 0,
  position: "absolute",
  right: 0,
  bottom: -12,
};

const TempIssuesNotice = ({ state, assessmentYear }) => {
  const navigate = useNavigate();
  const handleClick = (v) => {
    navigate("/atom-pro/income-tax-tan/e-proceeding-excel", {
      state: {
        column: "noticeSentDate",
        interval: v,
        assessmentYear,
      },
    });
  };
  return (
    <Box border="2px solid #C3C0C0" borderRadius="5px">
      <Grid container spacing={1}>
        <Grid item xs={2}>
          <Grid container bgcolor="#182F53">
            <Grid item xs={9}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                height="75px"
                borderRadius="5px"
              >
                <Typography color="#ffffff" sx={{ fontSize: "12px" }}>
                  Notice Sent / Issue
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={3}
              display="flex"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
              color="#ffffff"
            >
              <WorkHistoryIcon />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={10}>
          <Grid container spacing={1}>
              <Grid item xs={3}>
              <Box
                sx={{
                  width: "100%",
                  height: 65,
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Shadow style
                  borderRadius: "5px", // Rounded corners
                  bgcolor: "#ffffff", // Background color
                  border: "1px solid #c2d6d6", // Border color
                  my: "5px",
                  pl: "10px",
                  py: "5px",
                  position: "relative",
                  cursor: "pointer",
                }}
                onClick={() => handleClick("today")}
              >
                <Grid container>
                  <Grid item xs={9}>
                    <Typography sx={{ fontSize: "12px" }}>Today</Typography>
                    <Typography variant="h5" color="primary">
                      {state?.todayIssued}
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sx={imageContainerStyle}>
                    <img src={oneDay} alt="day0" height="30px" />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box
                sx={{
                  width: "100%",
                  height: 65,
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Shadow style
                  borderRadius: "5px", // Rounded corners
                  bgcolor: "#ffffff", // Background color
                  border: "1px solid #c2d6d6", // Border color
                  my: "5px",
                  pl: "10px",
                  py: "5px",
                  position: "relative",
                  cursor: "pointer",
                }}
                onClick={() => handleClick("last1week")}
              >
                <Grid container>
                  <Grid item xs={9}>
                    <Typography sx={{ fontSize: "12px" }}>Last 7</Typography>
                    <Typography variant="h5" color="primary">
                      {state?.last1WeekIssued}
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sx={imageContainerStyle}>
                    <img src={day7} alt="day7" height="30px" />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box
                sx={{
                  width: "100%",
                  height: 65,
                  p: 1,
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Shadow style
                  borderRadius: "5px", // Rounded corners
                  bgcolor: "#ffffff", // Background color
                  border: "1px solid #c2d6d6", // Border color
                  my: "5px",
                  position: "relative",
                  cursor: "pointer",
                }}
                onClick={() => handleClick("last15days")}
              >
                <Grid container>
                  <Grid item xs={9}>
                    <Typography sx={{ fontSize: "12px" }}>Last 15</Typography>
                    <Typography variant="h5" color="primary">
                      {state?.last15DaysIssued}
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sx={imageContainerStyle}>
                    <img src={last15days} alt="day7" height="30px" />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box
                sx={{
                  width: "100%",
                  height: 65,
                  p: 1,
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Shadow style
                  borderRadius: "5px", // Rounded corners
                  bgcolor: "#ffffff", // Background color
                  border: "1px solid #c2d6d6",
                  my: "5px",
                  position: "relative",
                  cursor: "pointer",
                }}
                onClick={() => handleClick("last1month")}
              >
                <Grid container>
                  <Grid item xs={9}>
                    <Typography sx={{ fontSize: "12px" }}>Last 30</Typography>
                    <Typography variant="h5" color="primary">
                      {state?.last1MonthIssued}
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sx={imageContainerStyle}>
                    <img src={month1} alt="day7" height="30px" />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item xs={2}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            height="75px"
            bgcolor="#182F53"
          >
            <Grid container color="white">
              <Grid item xs={12}>
                <Typography>All</Typography>
                <Typography variant="h5">{state?.last1MonthIssued}</Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid> */}
      </Grid>
    </Box>
  );
};
export default TempIssuesNotice;
